import { useMemo } from "react";
import { MenuItems } from "../../utils/getItemsMenu";
import { useAuth } from "../../AuthContext";

export function useMenuItems(fullMenu, isDrawer) {
  const { cenope } = useAuth();

  const ready = Boolean(cenope); // o la condición real de carga
  const isLite = ready && !cenope.idubic;

  const items = useMemo(() => {
    if (!ready) return [];

    let items = MenuItems.filter((item) =>
      isLite ? item.isLite : item.isFull,
    );

    items = items.filter((item) => {
      const key = item.key;

      if (fullMenu) {
        if (key === "auditar-stock") return false;
      } else {
        if (key === "home") return false;
      }

      if (isDrawer && key === "reubicacion") return false;

      return true;
    });

    return items.map(({ isLite, isFull, ...rest }) => rest);
  }, [ready, isLite, fullMenu, isDrawer]);

  return { items, ready };
}
